module.exports = __webpack_public_path__ + "media/images/pic/hero/all-dcac204dc7084071da67ecc3d87391cc.png";